import React, { Component } from 'react';

export default class StarsContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (

            <div>
                <p>Through the Stars was my final project for my Game Programming course at Northeastern University. I used the Unity game engine to develop a 2D platformer inspired by the gravity mechanics in Super Mario Galaxy. In addition to being one of my first experiences making a digital game from start to finish, this project was a great creative experience because I worked on every aspect of this game; in addition to scripting the animations, sounds, physics, and gameplay logic, I drew the sprites for the game. The game also features original music composed by my brother, Cole DiNome. You can download the game for free over on my itch.io page.</p>

            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/StarsContent.jsx